<template>
  <div>
    <h3 class="mb-5 text-secondary">{{ $t("page.post.title") }}</h3>
    <post-filters class="mb-5" />
    <infinite-scroll @load="retrievePosts">
      <post-table
        :posts="formatedPosts"
        :fields="fields"
        :actions="actions"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        no-local-sorting
      />
    </infinite-scroll>
  </div>
</template>

<script>
import { userMixin, appMixin } from "./../mixins";

import PostFilters from "./../components/Post/PostFilters";
import PostTable from "./../components/Post/PostTable";
import { EventBus } from "./../eventBus.js";
import InfiniteScroll from "./../components/Base/BaseInfiniteScroll";

export default {
  components: {
    PostFilters,
    PostTable,
    InfiniteScroll
  },
  mixins: [userMixin, appMixin],
  async mounted() {
    // this.retrievePosts(true);
    // EventBus.$on("eventBusReloadPosts", () => this.retrievePosts(true));
  },
  data() {
    return {
      actions: [
        {
          label: "button.manage",
          variant: "secondary",
          callbackFunc: this.goToPostDetails
        },
        {
          label: "button.delete",
          variant: "orange",
          callbackFunc: this.openDeleteConfirmationModal
        }
      ]
    };
  },
  computed: {
    fields() {
      let initFields = [
        { key: "condominiumName", label: "condominium", sort: false },
        { key: "createdAt", label: "date", sort: true },
        { key: "body", label: "postContent", sort: true },
        { key: "photo", label: "photo", sort: false },
        { key: "hasDocuments", label: "file", sort: false },
        { key: "commentsNumber", label: "commentsShort", sort: false },
        { key: "likesNumber", label: "L", sort: false },
        { key: "viewsNumber", label: "V", sort: false },
        { key: "author", label: "author", sort: false },
        // { key: "role", label: "roleInCondominium", sort: false },
        // { key: "group", label: "groupInCondominium", sort: false },
        { key: "reported", label: "reported", sort: false },
        { key: "actions", label: "" }
      ];
      if (this.$is1Board) {
        initFields.splice(8, 0, {
          key: "group",
          label: "groupInCondominium",
          sort: false
        });
        const photoIdx = initFields.findIndex(i => i.key === "photo");
        initFields[photoIdx] = { key: "photos", label: "photos", sort: false };
      } else {
        initFields.splice(6, 0, {
          key: "role",
          label: "roleInCondominium",
          sort: false
        });
        initFields = initFields.filter(
          field => !["likesNumber", "viewsNumber"].includes(field.key)
        );
      }
      return initFields;
    },
    posts() {
      return this.$store.getters["post/getPosts"].map(post => ({
        ...post,
        ownerId: post.ownerId || {
          role: "deleted",
          profile: {
            name: this.$t("userRoles.deleted"),
            surname: this.$t("userRoles.deleted")
          }
        }
      }));
    },
    formatedPosts() {
      return this.posts.map(item => {
        return {
          id: item._id,
          condominiumId: item.condominiumId._id,
          condominiumName: item.condominiumId.name || "-",
          createdAt: item.createdAt,
          body: item.body,
          photo: item.photo,
          photos: item.photos,
          group: this.$is1Board && item.groups ? item.groups[0] : null,
          commentsNumber: item.comments?.length || 0,
          likesNumber: item.likes?.length || 0,
          viewsNumber: item.viewedBy?.length || 0,
          hasDocuments: item.documents && item.documents.length > 0,
          reported:
            item.reported || item.comments.find(comment => comment.reported),
          authorAvatar: this.$_getUserProfilePhoto(item.ownerId.profile),
          author: this.$_getUserFullName(item.ownerId.profile),
          role: item.ownerId.condominiums
            ? this.getRoleInCondominium(item.condominiumId._id, item.ownerId)
            : item.ownerId.role
        };
      });
    },
    sortBy: {
      get() {
        return this.$store.getters["post/getSortBy"];
      },
      set(value) {
        this.$store.commit("post/SET_SORT_BY", value);
        this.retrievePosts(true);
      }
    },
    sortDesc: {
      get() {
        return this.$store.getters["post/getSortDesc"];
      },
      set(value) {
        this.$store.commit("post/SET_SORT_DESC", value);
        this.retrievePosts(true);
      }
    }
  },
  methods: {
    getRoleInCondominium(condominiumId, owner) {
      return (
        owner.condominiums.find(c => {
          return c.condominiumId === condominiumId;
        })?.role || "-"
      );
    },
    goToPostDetails(postId, condominiumId) {
      this.$router.push({
        name: "PostDetails",
        params: { condominiumId, postId }
      });
    },
    openDeleteConfirmationModal(postId, condominiumId) {
      this.$store.commit("confirm/SET_CONFIRM", {
        confirmBtnCallback: this.deletePost,
        confirmBtnParams: { postId, condominiumId },
        type: "DELETE"
      });
    },
    async deletePost({ postId, condominiumId }) {
      try {
        this.$store.commit("loader/SET_LOADER", {});

        await this.$store.dispatch("post/deletePost", {
          postId,
          condominiumId
        });

        await this.retrievePosts();
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("loader/RESET");
      }
    },
    async retrievePosts(initial) {
      return this.$store.dispatch("post/retrieveUserPosts", {
        initial,
        hasPagination: true,
        type: "post"
      });
    }
  },
  beforeDestroy() {
    EventBus.$off("eventBusReloadPosts");
  }
};
</script>

<style lang="scss" scoped></style>
